import React, { createContext, useState, useContext, useEffect } from 'react';
import { auth } from '../services/firebase';
import { signInAnonymously } from 'firebase/auth';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    // Initialize state from localStorage if available
    const [user, setUser] = useState(() => {
        try {
            const storedUser = localStorage.getItem('user_session');
            return storedUser ? JSON.parse(storedUser) : null;
        } catch (error) {
            console.error("Error parsing user session:", error);
            return null;
        }
    });

    // Sync state changes to localStorage
    useEffect(() => {
        if (user) {
            localStorage.setItem('user_session', JSON.stringify(user));
        } else {
            localStorage.removeItem('user_session');
        }
    }, [user]);

    const [fbUser, setFbUser] = useState(null);

    // Silently authenticate with Firebase to allow Storage/DB access
    useEffect(() => {
        signInAnonymously(auth)
            .then((cred) => {
                console.log("Firebase: Signed in anonymously:", cred.user.uid);
                setFbUser(cred.user);
            })
            .catch((error) => console.error("Firebase Auth Error:", error));
    }, []);

    const users = [
        { username: 'DevOps', password: 'sec-hat_devops01', role: 'admin', name: 'DevOps Admin' },
        { username: 'usuario', password: 'user123', role: 'user', name: 'Usuario Regular' },
        { username: 'Jsalamea', password: 'pass0122', role: 'admin', name: 'J. Salamea' },
        { username: 'mktuser', password: 'marxi0122', role: 'marketing', name: 'Marketing User' },
        { username: 'Johamkt', password: 'jah2026mkt', role: 'marketing', name: 'Joha Marketing' },
        { username: 'jahermkt', password: 'jah2026mkt', role: 'marketing', name: 'Jaher Marketing' }
    ];

    const login = (username, password) => {
        const foundUser = users.find(
            u => u.username === username && u.password === password
        );

        if (foundUser) {
            const { password, ...userWithoutPassword } = foundUser;
            setUser(userWithoutPassword);
            return { success: true, user: userWithoutPassword };
        }

        return { success: false, message: 'Usuario o contraseña incorrectos' };
    };

    const logout = () => {
        setUser(null);
    };

    const value = {
        user,
        fbUser,
        login,
        logout,
        isAuthenticated: !!user,
        isAdmin: user?.role === 'admin',
        canManageStatus: user?.role === 'admin',
        isAuthorizedDomain: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.endsWith('firebaseapp.com') || window.location.hostname.endsWith('web.app') || window.location.hostname === 'jaher.cloud'
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
